import * as React from "react";
import { withFormik, FormikProps, Field, Form as FForm } from "formik";
import { Form, Icon, Button } from "antd";
import { NormalizedErrorMap } from "@bakbak/controller";

import { InputField } from "../../../util/InputField";

const FormItem = Form.Item;

interface FormValues {
  email: string;
}
interface Props {
  onComplete: () => void;
  submit: (values: FormValues) => Promise<NormalizedErrorMap | null>;
}

class SendForgotPasswordEmailForm extends React.PureComponent<
  FormikProps<FormValues> & Props
> {
  render() {
    return (
      <FForm style={{ display: "flex" }}>
        <div style={{ width: 400, margin: "auto" }}>
          <Field
            name="email"
            prefix={
              <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} /> as any
            }
            placeholder="email"
            component={InputField}
          />
          <FormItem>
            <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
              Reset Password
            </Button>
          </FormItem>
        </div>
      </FForm>
    );
  }
}

export const SendForgotPasswordEmailView = withFormik<Props, FormValues>({
  mapPropsToValues: () => ({ email: "" }),
  handleSubmit: async (values, { props, setErrors }) => {
    const response = await props.submit(values);
    if (response) {
      props.onComplete();
    } else {
      console.log("Some error occured");
    }
  }
})(SendForgotPasswordEmailForm);



// WEBPACK FOOTER //
// ./src/modules/auth/sendForgotPasswordEmail/SendForgotPasswordEmailView.tsx